<template>
	<div>
		<NavBar />
		<main role="main">
			<div class="container">
				<div class="row">
					<div class="col-md-8" v-if="checkSocio">
						<div class="row justify-content-center">
							<div class="col-md-12 text-center mb-3">
								<h5 class="mb-3">Cadastro de Associados</h5>
								<p>
									Informe o seu
									<strong>CPF</strong>
									. Verificaremos se você já fez parte do nosso cadastro de sócios.
								</p>
							</div>
							<div class="col-md-6">
								<form @submit.prevent="verificar">
									<div class="form-group">
										<label>CPF</label>
										<input
											type="text"
											:disabled="isLoading || isSocio"
											class="form-control"
											:class="{ 'is-invalid': $v.form.cpf.$error, 'is-valid': !$v.form.cpf.$invalid }"
											v-mask="['###.###.###-##']"
											v-model.trim="$v.form.cpf.$model"
											autocomplete="off"
											placeholder="Informe o seu CPF"
										/>
										<div class="invalid-feedback" v-if="!$v.form.cpf.validCPF">
											Informe um
											<strong>CPF</strong>
											válido.
										</div>
										<div class="invalid-feedback" v-if="!$v.form.cpf.$pending && !$v.form.cpf.isUnique">
											O
											<strong>CPF</strong>
											informado já foi cadastrado.
										</div>
									</div>
									<button type="submit" class="btn btn-primary btn-block btn-flat mb-3">
										<span v-if="!isLoading">Verificar</span>
										<span v-if="isLoading">
											<i class="fa fa-circle-o-notch fa-spin"></i>
											Verificando... aguarde!
										</span>
									</button>
								</form>
							</div>
						</div>
					</div>
					<div class="col-md-8" v-if="!checkSocio">
						<loading :active.sync="isLoading" :can-cancel="false" :color="'#e99a60'" :is-full-page="false"></loading>
						<div class="col-md-12 text-center mb-3">
							<h5 class="mb-3">Seja um sócio</h5>
							<span v-if="isSocio">
								<p>
									Olá,
									<strong>{{ form.nome }}</strong>
								</p>
								<p>Complete o seu cadastro e confirme seu status de associado na Rede de Estudos Rurais.</p>
							</span>
							<span v-else>
								<p>Cadastre-se agora e seja um sócio da Rede de Estudos Rurais.</p>
								<p>Seu cadastro será avaliado e você receberá um e-mail informando sobre a sua solicitação.</p>
							</span>
							<hr />
						</div>
						<form role="form" @submit.prevent="submit">
							<div class="row">
								<div class="col-md-12">
									<h5>Dados Pessoais</h5>
									<div class="form-group">
										<label>Nome Completo</label>
										<input
											type="text"
											class="form-control"
											:disabled="isLoading || isSocio"
											:class="{ 'is-invalid': $v.form.nome.$error, 'is-valid': !$v.form.nome.$invalid }"
											v-model.trim="$v.form.nome.$model"
											autocomplete="off"
											placeholder="Digite o seu Nome Completo"
										/>
										<div class="invalid-feedback" v-if="!$v.form.nome.minLength">
											O Nome Completo deve conter no mínimo
											<strong>10 caracteres</strong>
											.
										</div>
										<div class="invalid-feedback" v-if="!$v.form.nome.required">
											O
											<strong>Nome Completo</strong>
											é obrigatório.
										</div>
									</div>
									<div class="form-group">
										<label>Endereço</label>
										<input
											type="text"
											class="form-control"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.endereco.$error, 'is-valid': !$v.form.endereco.$invalid }"
											v-model.trim="$v.form.endereco.$model"
											autocomplete="off"
											placeholder="Digite o seu endereço"
										/>
										<div class="invalid-feedback" v-if="!$v.form.endereco.minLength">
											O seu endereço deve conter no mínimo 10 caracteres.
										</div>
										<div class="invalid-feedback" v-if="!$v.form.endereco.required">
											O
											<strong>Endereço</strong>
											é obrigatório.
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<label>Estado</label>
										<select
											class="form-control"
											@change="getCidades()"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.uf.$error, 'is-valid': !$v.form.uf.$invalid }"
											v-model="form.uf"
										>
											<option disabled value>Selecione...</option>
											<option v-for="uf in list" v-bind:key="uf.id" v-bind:value="uf">{{ uf.sigla }}</option>
										</select>
										<div class="invalid-feedback" v-if="$v.form.uf.$error && !$v.form.uf.required">
											Escolha um
											<strong>Estado</strong>
											.
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>Cidade</label>
										<select
											class="form-control"
											:disabled="cidades.length == 0"
											:class="{ 'is-invalid': $v.form.cidade.$error, 'is-valid': !$v.form.cidade.$invalid }"
											v-model="form.cidade"
										>
											<option value v-if="cidades.length == 0">Selecione o UF</option>
											<option value disabled v-if="cidades.length > 0">Selecione...</option>
											<option v-for="cidade in cidades" v-bind:key="cidade.id" :value="cidade.nome">
												{{ cidade.nome }}
											</option>
										</select>
										<div class="invalid-feedback" v-if="$v.form.cidade.$error && !$v.form.cidade.required">
											Escolha uma
											<strong>Cidade</strong>
											.
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>CEP</label>
										<input
											type="text"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.cep.$error, 'is-valid': !$v.form.cep.$invalid }"
											class="form-control"
											placeholder="99999-999"
											v-model="$v.form.cep.$model"
											autocomplete="off"
											v-mask="['#####-###']"
										/>
										<div class="invalid-feedback" v-if="$v.form.cep.$error && !$v.form.cep.minLength">
											CEP inválido.
										</div>
										<div class="invalid-feedback" v-if="$v.form.cep.$error && !$v.form.cep.required">
											Campo obrigatório.
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="form-group">
										<label>Sexo</label>
										<select
											class="form-control"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.sexo.$error, 'is-valid': !$v.form.sexo.$invalid }"
											v-model="form.sexo"
										>
											<option disabled value>Selecione...</option>
											<option value="M">Masculino</option>
											<option value="F">Feminino</option>
										</select>
										<div
											class="invalid-feedback"
											v-if="$v.form.sexo.$error && !$v.form.sexo.$pending && !$v.form.sexo.required"
										>
											Campo obrigatório.
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<label>Telefone</label>
										<input
											type="tel"
											class="form-control"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.telefone.$error, 'is-valid': !$v.form.telefone.$invalid }"
											placeholder="(99) 99999-9999"
											v-model="$v.form.telefone.$model"
											autocomplete="off"
											v-mask="['(##) ####-####', '(##) #####-####']"
										/>
										<div class="invalid-feedback" v-if="!$v.form.telefone.required">Campo obrigatório.</div>
										<div class="invalid-feedback" v-if="!$v.form.telefone.minLength">
											Insira um número de telefone válido.
										</div>
									</div>
								</div>
							</div>
							<hr />
							<div class="row">
								<div class="col-md-12">
									<h5>Dados de Acesso</h5>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<label>E-mail</label>
										<input
											type="text"
											:disabled="isLoading"
											class="form-control"
											:class="{ 'is-invalid': $v.form.email.$error, 'is-valid': !$v.form.email.$invalid }"
											v-model.trim="$v.form.email.$model"
											autocomplete="off"
										/>
										<div
											class="invalid-feedback"
											v-if="$v.form.email.$error && !$v.form.email.$pending && !$v.form.email.required"
										>
											Campo obrigatório.
										</div>
										<div class="invalid-feedback" v-if="!$v.form.email.$pending && !$v.form.email.email">
											Informe um
											<strong>e-mail</strong>
											válido.
										</div>
										<div class="invalid-feedback" v-if="!$v.form.email.$pending && !$v.form.email.isUnique">
											O
											<strong>e-mail</strong>
											informado já foi cadastrado.
										</div>
									</div>
									<div class="form-group">
										<label>CPF</label>
										<input
											type="text"
											:disabled="isLoading || isSocio"
											class="form-control"
											:class="{ 'is-invalid': $v.form.cpf.$error, 'is-valid': !$v.form.cpf.$invalid }"
											v-mask="['###.###.###-##']"
											v-model.trim="$v.form.cpf.$model"
											autocomplete="off"
										/>
										<div class="invalid-feedback" v-if="!$v.form.cpf.validCPF">
											Informe um
											<strong>CPF</strong>
											válido.
										</div>
										<div class="invalid-feedback" v-if="!$v.form.cpf.$pending && !$v.form.cpf.isUnique">
											O
											<strong>CPF</strong>
											informado já foi cadastrado.
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<label>Senha</label>
										<input
											type="password"
											:disabled="isLoading"
											class="form-control"
											:class="{ 'is-invalid': $v.form.password.$error, 'is-valid': !$v.form.password.$invalid }"
											v-model.trim="$v.form.password.$model"
											autocomplete="nope"
										/>
										<div class="invalid-feedback" v-if="!$v.form.password.required">A senha é obrigatória.</div>
										<div class="invalid-feedback" v-if="!$v.form.password.minLength">
											A senha deve conter no mínimo 8 caracteres.
										</div>
									</div>
									<div class="form-group">
										<label>Repita a sua Senha</label>
										<input
											type="password"
											:disabled="isLoading"
											class="form-control"
											:class="{
												'is-invalid': $v.form.repeatPassword.$error,
												'is-valid': !$v.form.repeatPassword.$invalid && $v.form.repeatPassword.$model,
											}"
											v-model.trim="$v.form.repeatPassword.$model"
											autocomplete="nope"
										/>
										<div class="invalid-feedback" v-if="!$v.form.password.repeatPassword">
											As senhas devem ser iguais.
										</div>
									</div>
								</div>
							</div>

							<hr />

							<div class="row">
								<div class="col-md-12">
									<h5>Dados Profissionais</h5>
									<div class="form-group">
										<label>Profissão</label>
										<input
											type="text"
											class="form-control"
											:class="{ 'is-invalid': $v.form.profissao.$error, 'is-valid': !$v.form.profissao.$invalid }"
											:disabled="isLoading"
											v-model.trim="$v.form.profissao.$model"
											autocomplete="off"
											placeholder="Digite a sua profissão"
										/>
										<div class="invalid-feedback" v-if="!$v.form.profissao.required">Campo obrigatório.</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<label>Formação</label>
										<select
											class="form-control"
											:disabled="isLoading"
											v-model="$v.form.formacao.$model"
											:class="{ 'is-invalid': $v.form.formacao.$error, 'is-valid': !$v.form.formacao.$invalid }"
										>
											<option disabled value>Selecione...</option>
											<option value="G">Graduado</option>
											<option value="M">Mestre</option>
											<option value="D">Doutor</option>
											<option value="PD">Pós-Doutor</option>
										</select>
										<div class="invalid-feedback" v-if="!$v.form.formacao.required">Campo obrigatório.</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>Instituição</label>
										<input
											type="text"
											class="form-control"
											:class="{ 'is-invalid': $v.form.instituicao.$error, 'is-valid': !$v.form.instituicao.$invalid }"
											:disabled="isLoading"
											v-model.trim="$v.form.instituicao.$model"
											autocomplete="off"
											placeholder="Nome da instituição"
										/>
										<div class="invalid-feedback" v-if="$v.form.instituicao.$error && !$v.form.instituicao.required">
											Campo obrigatório.
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>Departamento do Curso</label>
										<input
											type="text"
											class="form-control"
											:class="{
												'is-invalid': $v.form.departamento.$error,
												'is-valid': !$v.form.departamento.$invalid,
											}"
											:disabled="isLoading"
											v-model.trim="$v.form.departamento.$model"
											autocomplete="off"
											placeholder="Nome do departamento"
										/>
										<div class="invalid-feedback" v-if="!$v.form.departamento.required">Campo obrigatório.</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<label>Currículo Lattes</label>
										<input
											type="text"
											class="form-control"
											:class="{ 'is-invalid': $v.form.lattes.$error, 'is-valid': !$v.form.lattes.$invalid }"
											:disabled="isLoading"
											v-model.trim="$v.form.lattes.$model"
											autocomplete="off"
											placeholder="Informe o link do seu currículo na plataforma Lattes"
										/>
										<div class="invalid-feedback" v-if="!$v.form.lattes.required">Campo obrigatório.</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 text-center">
									<button type="submit" class="btn btn-primary btn-flat" :disabled="isLoading">
										<span v-if="!isLoading">Cadastrar</span>
										<span v-if="isLoading">
											<i class="fa fa-circle-o-notch fa-spin"></i>
											Cadastrando... aguarde!
										</span>
									</button>
								</div>
							</div>
						</form>
					</div>
					<div class="col-md-4">
						<ColunaSocio />
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import ColunaSocio from '@/components/ColunaSocio.vue';
import { required, minLength, sameAs, email } from 'vuelidate/lib/validators';
import { baseApiUrl } from '@/global';
import { validaCpf } from '@/helpers';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const lodash = require('lodash');
const axios = require('axios');

const validCPF = (value) => validaCpf(value);

export default {
	name: 'register',
	data: function() {
		return {
			isLoading: false,
			isSocio: false,
			checkSocio: true,
			form: {
				nome: '',
				endereco: '',
				uf: '',
				cidade: '',
				cep: '',
				sexo: '',
				telefone: '',
				email: '',
				cpf: '',
				password: '',
				repeatPassword: '',
				profissao: '',
				formacao: '',
				instituicao: '',
				departamento: '',
				lattes: '',
			},
			ufs: [],
			cidades: [],
		};
	},
	components: {
		NavBar,
		ColunaSocio,
		Loading,
	},
	validations: {
		form: {
			nome: {
				required,
				minLength: minLength(10),
			},
			endereco: {
				required,
				minLength: minLength(10),
			},
			uf: {
				required,
			},
			cidade: {
				required,
			},
			cep: {
				required,
				minLength: minLength(9),
			},
			telefone: {
				required,
				minLength: minLength(14),
			},
			sexo: {
				required,
			},
			password: {
				required,
				minLength: minLength(8),
			},
			repeatPassword: {
				sameAsPassword: sameAs('password'),
			},
			email: {
				required,
				email,
				isUnique(value) {
					if (value === '') return true;
					return new Promise((resolve, reject) => {
						axios
							.get(baseApiUrl + 'api/socios/verificaEmail?email=' + this.form.email)
							.then((response) => {
								resolve(response.data.response);
							})
							.catch(() => {
								reject();
							});
					});
				},
			},
			cpf: {
				required,
				validCPF,
				isUnique(value) {
					if (value === '') return true;
					if (value.length < '14') return true;
					return new Promise((resolve, reject) => {
						axios
							.get(baseApiUrl + 'api/socios/verificaCPF?cpf=' + this.form.cpf)
							.then((response) => {
								resolve(response.data.response);
							})
							.catch(() => {
								reject();
								this.$toasted.global.defaultError({
									mensagem: 'Não foi possível conectar ao servidor. Verifique a sua conexão e tente novamente.',
								});
								return false;
							});
					});
				},
			},
			profissao: {
				required,
			},
			formacao: {
				required,
			},
			instituicao: {
				required,
			},
			departamento: {
				required,
			},
			lattes: {
				required,
			},
		},
	},
	methods: {
		verificar() {
			this.$v.form.cpf.$touch();
			if (!this.$v.form.cpf.$invalid) {
				this.isLoading = true;
				axios
					.post(baseApiUrl + 'api/socios/verificaSocio', {
						cpf: this.form.cpf,
					})
					.then((response) => {
						this.isLoading = false;

						if (response.data.response == 'found') {
							this.form.cpf = response.data.data.cpf;
							this.form.nome = response.data.data.nome;
							this.isSocio = true;
							this.$toasted.global.defaultSuccess(response.data);
						}

						this.checkSocio = false;
					})
					.catch(() => {
						this.isLoading = false;
						this.$toasted.global.defaultError({
							mensagem: 'Não foi possível conectar ao servidor. Verifique a sua conexão e tente novamente.',
						});
					});
			}
		},
		submit() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				if (!this.isSocio) {
					axios
						.post(baseApiUrl + 'api/socios/socio', { data: this.form })
						.then((response) => {
							if (response.data.response == 'success') {
								this.$toasted.global.defaultSuccess(response.data);
								this.$router.push('/');
							} else if (response.data.response == 'error') {
								this.$toasted.global.defaultError(response.data);
							}
						})
						.catch(() => {
							this.$toasted.global.defaultError({
								mensagem: 'Não foi possível realizar o seu cadastro. Tente novamente mais tarde.',
							});
						});
				} else {
					axios
						.put(baseApiUrl + 'api/socios/socio', { data: this.form })
						.then((response) => {
							if (response.data.response == 'success') {
								this.$toasted.global.defaultSuccess(response.data);
								this.$router.push('/');
							} else if (response.data.response == 'error') {
								this.$toasted.global.defaultError(response.data);
							}
						})
						.catch(() => {
							this.$toasted.global.defaultError({
								mensagem: 'Não foi possível realizar o seu cadastro. Tente novamente mais tarde.',
							});
						});
				}
			}
		},
		getUfs() {
			axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados').then((response) => {
				this.ufs = response.data;
			});
		},
		getCidades() {
			this.form.cidade = '';
			axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados/' + this.form.uf.id + '/municipios').then((response) => {
				this.cidades = response.data;
			});
		},
	},
	mounted() {
		if (this.$auth.user().data != undefined) {
			this.$auth.logout();
		}

		this.getUfs();
	},
	computed: {
		list() {
			return lodash.orderBy(this.ufs, 'sigla');
		},
	},
};
</script>
